import { Section } from "./Section";

import { Markdown } from "~/components/Markdown";
import { Text } from "~/components/Text";
import type { AppointmentDetails } from "~/utils/appointment.utils.server";

interface AppointmentInstructionsProps {
  subject: AppointmentDetails["subject"];
}

export function AppointmentInstructions({ subject }: AppointmentInstructionsProps) {
  if (!subject.instructions) return null;

  return (
    <Section
      data-variant="AppointmentInstructions"
      title={<Text i18nKey="Confirmation.instructions" />}
    >
      <Section.Item>
        <Markdown text={subject.instructions} />
      </Section.Item>
    </Section>
  );
}
